import PropTypes from 'prop-types';

export const MY_ACCOUNT_OPTIONS = {
  PROFILE: 'profile',
  NOTIFICATIONS: 'notifications',
};

const accountScreenOption = PropTypes.oneOf([
  MY_ACCOUNT_OPTIONS.PROFILE,
  MY_ACCOUNT_OPTIONS.NOTIFICATIONS,
]);

export default accountScreenOption;
